import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Toolbar, Typography, Box } from "@mui/material";
import { deleteSummary, getBookHistory } from "../../../services/booksService";
import { setBooksState } from "../../../redux/features/booksSlice";
import TableRowsLoader from "../../../components/common/Loader/tableLoader";
import BooksTable from "../../../components/booksTable/BooksTable";
import BooksDrawer from "../../../components/booksDrawer/BooksDrawer";
import CustomSnackbar from "../../../components/common/Snackbar/CustomSnackbar";
import { getSettingsDetails } from "../../../services/settingsService";
import { SettingsDetailsType } from "../../../types/genericType";

const CloseBooks = () => {
  const [search, setSearch] = useState("");
  const { books } = useSelector((state: any) => state.bookState);
  const [onSuccess, setOnSuccess] = useState(false);
  const [snackbarMsg, setSnackbarMsg] = useState("");
  const dispatch = useDispatch();

  const [settingsData, setSettingsData] = useState<SettingsDetailsType>({
    LoanMessage: "",
    InvestmentMessage: "",
    Quote: "",
    NextCheckNumber: 0,
    StatementEmailSubject: "",
    StatementEmailBody: "",
    MonthEndDescription: "",
    ManagementFees: "",
    ManagementRate: "",
    VariableInvestmentRate: "",
    TotalRate: "",
    CompanyEmail: "",
    ManagementFirm: "",
  });

  const getSettingsData = () => {
    getSettingsDetails()
      .then((res: SettingsDetailsType) => {
        setSettingsData(res);
      })
      .catch((err: any) => {
        console.log(err);
      });
  };

  const initialLoad = () => {
    getBookHistory().then((res) => {
      dispatch(setBooksState(res));
    });
    getSettingsData();
  };

  useEffect(() => {
    initialLoad();
  }, []);

  const deleteTransaction = (id: number) => {
    deleteSummary(id)
      .then(() => {
        window.location.reload();
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleSearchChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ): void => {
    setSearch(event.target.value);
  };

  const clearSearch = () => {
    setSearch("");
  };

  const filteredBooks = books.filter((book: any) => {
    return book.description.toLowerCase().includes(search.toLowerCase());
  });

  return (
    <>
      <Toolbar
        sx={{
          justifyContent: "space-between",
          margin: "0px 15px",
        }}
      >
        <Typography className="transactions-history-title">
          Close Books
        </Typography>
        <BooksDrawer
          settingsData={settingsData}
          onSuccess={setOnSuccess}
          setSnackbarMsg={setSnackbarMsg}
        />
      </Toolbar>
      <Box sx={{ margin: "20px 40px" }}>
        {books.length > 0 ? (
          <BooksTable
            data={filteredBooks}
            search={search}
            deleteTransaction={deleteTransaction}
            onSearchChange={handleSearchChange}
            clearSearch={clearSearch}
            // setOpenEditDrawer={setOpenEditDrawer}
            // updateSelectedTransaction={updateSelectedTransaction}
          />
        ) : (
          <TableRowsLoader rowsNum={10} />
        )}
        <CustomSnackbar
          open={onSuccess}
          message={snackbarMsg}
          setOpen={setOnSuccess}
        />
      </Box>
    </>
  );
};

export default CloseBooks;
